import React from 'react';
import './NoticeBoardWidget.css';
import templates from './templates';

export const NoticeBoardWidget = ({
  data = { notices: [] },
  template = 'Board',
  title = 'לוח מודעות',
  showTitle = true,
  scale=1
}) => {
  const TemplateComponent = templates[template] || templates.Board;

  return <TemplateComponent data={data} title={title} showTitle={showTitle} scale={scale} />;
};